import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, map } from 'rxjs';
//import { IAppConfig } from '../models/app-config.model';
//import { AppConfig } from '../../shared/contants/app-config';
import { AppConfig } from "../../design/app";

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private appConfig: any;
  private http: HttpClient;

  constructor(private readonly httpHandler: HttpBackend) {
    this.appConfig = AppConfig;
    this.http = new HttpClient(httpHandler);
  }

  // Method to load the configuration from the server
  public loadConfig() {
    //const httpClient = this.http.get(AppConfig.URL) as Observable<IAppConfig>;
    //return firstValueFrom(httpClient)
    //  .then((appConfig: IAppConfig) =>{
    //     this.appConfig = appConfig
    //  }) // Set the loaded configuration
    //  .catch((err: any) => {
    //    console.error('Failed to load configuration'); // Log the error
    //    throw err; // Rethrow the error
    //  }); // Handle any errors
    return null;
  }

  // Method to get the loaded configuration
  get() {
    return this.appConfig;
  }
}
